import { DialogViewPDF } from "#common/Dialog/DialogViewPDF"
import { InputSelect } from "#common/input/InputSelect"
import PERMISOS from "#constants/perfiles"
import { COLOR_PRIMARY, COLOR_WHITE } from "#constants/Styles"
import { useApi } from "#hooks/useApi"
import { UseHasPermission } from "#hooks/useHasPermission"
import FormCursoColaborador from "#training/components/FormCursoColaborador"
import Tarjeta from "#training/components/Tarjeta/Tarjeta"
import {
	TarjetaPdfProvider,
	UseTarjetaPdfContext,
} from "#training/contexts/contextsTarjeta"
import { UseSetExpanded } from "#training/redux/actions"
import { UseReduxTraining } from "#training/redux/slice"
import {
	courseCollaboratorIdGet,
	courseCollaboratorListGet,
} from "#training/services/Api"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Box, Skeleton, Stack } from "@mui/material"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Unstable_Grid2"
import { ChangeTitle } from "Components/menu/funciones"
import { useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"

const Colaborador = ({ id }) => {
	ChangeTitle("Cursos del colaborador")
	const isRh = UseHasPermission([PERMISOS.RH_ALL, PERMISOS.SEGURIDAD_HIGIENE])
	const { reload } = UseReduxTraining()
	const user = useSelector((state) => state.user)
	const setExpanded = UseSetExpanded()
	const [year, setYear] = useState(new Date().getFullYear())
	const colaborador_id = useMemo(
		() => id || user.colaborador.id,
		[id, user.colaborador.id]
	)
	const params = useMemo(
		() => ({
			autoFetch: true,
			params: { id: colaborador_id, params: { year } },
			reload: reload,
		}),
		[colaborador_id, reload, year]
	)
	const { data, loading } = useApi(courseCollaboratorListGet, params)

	useEffect(() => {
		if (data?.count > 1) setExpanded(data?.cursos[0]?.category)
	}, [data, setExpanded])

	const Courses = () => {
		if (!data?.count)
			return (
				<Typography textAlign={"center"} variant="h2">
					No hay cursos
				</Typography>
			)
		else
			return data?.cursos.map((curso, index) => {
				return <AccordionCategory {...{ data: curso }} />
			})
	}

	const list_years = useMemo(() => {
		const years = []
		for (let index = 2023; index <= new Date().getFullYear() + 1; index++) {
			years.push({ año: index })
		}
		return years
	}, [])

	if (loading)
		return (
			<Box>
				<Skeleton variant="rounded" width={"95vw"} height={"90vh"} />
			</Box>
		)
	return (
		<Box
			width={"94vw"}
			sx={{ p: 1 }}
			display={"flex"}
			flexDirection={"column"}
			alignItems={"center"}
			gap={2}
		>
			<Box width={"25%"}>
				{isRh && (
					<Stack
						direction={"row"}
						justifyContent="center"
						alignContent={"center"}
						spacing={3}
					>
						<FormCursoColaborador colaboradorId={colaborador_id} />
						<InputSelect
							label="Año"
							data={list_years}
							value={year}
							setValue={(value) => setYear(value)}
							dataId="año"
							dataLabel="año"
						/>
					</Stack>
				)}
			</Box>
			<Box width={"94vw"} sx={{ p: 1 }} display={"flex"} flexDirection={"column"} gap={2}>
				<TarjetaPdfProvider>
					<Courses />
					<ViewPdfTarjeta />
				</TarjetaPdfProvider>
			</Box>
		</Box>
	)
}

export default Colaborador

export const ViewPdfTarjeta = () => {
	const { pdf, setPdf, cursoId: id } = UseTarjetaPdfContext()
	const params = useMemo(() => ({ id, params: { url: true } }), [id])
	const { data, loading } = useApi(courseCollaboratorIdGet, {
		autoFetch: pdf,
		params,
	})

	return (
		<DialogViewPDF
			open={pdf}
			setOpen={setPdf}
			urlFile={data?.url}
			fileName={data?.name}
			title="Certificado"
			loading={loading}
		/>
	)
}

export function AccordionCategory({ data, setOpenPdf }) {
	const setExpanded = UseSetExpanded()
	const { expanded } = UseReduxTraining()
	const { category, count, data: cursos } = data
	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false)
	}

	return (
		<div width={"100%"}>
			<Accordion expanded={expanded === category} onChange={handleChange(category)}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon sx={{ color: COLOR_WHITE }} />}
					aria-controls="panel1-content"
					id="panel1-header"
					sx={{ backgroundColor: COLOR_PRIMARY }}
				>
					<Typography component="span" sx={{ fontWeight: "bold", color: COLOR_WHITE }}>
						{`${category}: ${count}`.toUpperCase()}
					</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={2} width={"100%"}>
						{cursos.map((curso, index) => {
							return (
								<Grid key={curso?.id} xs={12} md={6} xl={4}>
									<Tarjeta curso={curso} setOpenPdf={setOpenPdf} showColaborador />
								</Grid>
							)
						})}
					</Grid>
				</AccordionDetails>
			</Accordion>
		</div>
	)
}
